import type { FreemiumProduct } from '../components/Freemium/interfaces';

const getFreemiumProductByType = (freemiumProducts: Array<FreemiumProduct>, productTypeCode: number) => {
  return freemiumProducts.find((p) => p.type === productTypeCode);
};

export { getFreemiumProductByType };
